import React from 'react';
import { OrderedMap } from 'immutable';
import classNames from 'classnames';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import { EditableCellTypes } from 'shared/flux/stores/cuesheet/CuesheetConstants';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const PrintableTableHeader = ({ guestColumns, presetDurationDisplayType }) => {
  let formattedHeaderCells = OrderedMap();

  if (!guestColumns) return null;

  /*
    TODO: find a way to use an actual border for the header row intead of faking with class
    'faux-printable-header-border'
  */
  guestColumns.forEach((column, key) => {
    if (key === EditableCellTypes.ItemNumber) {
      const numberHeaderClasses = classNames(
        'item-number-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const ItemNumberHeaderCell = (
        <th className={numberHeaderClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">#</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(
        EditableCellTypes.ItemNumber,
        ItemNumberHeaderCell,
      );

      return formattedHeaderCells;
    }

    if (key === EditableCellTypes.ItemStartTime) {
      const startTimeHeaderClasses = classNames(
        'start-time-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const StartTimeHeaderCell = (
        <th className={startTimeHeaderClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">Start</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(
        EditableCellTypes.ItemStartTime,
        StartTimeHeaderCell,
      );

      return formattedHeaderCells;
    }

    if (key === EditableCellTypes.ItemPresetDuration) {
      let presetHeaderText = 'Preset';
      if (presetDurationDisplayType === TimeDisplayTypes.clockTime)
        presetHeaderText = TimeDisplayTypes.clockTime;
      const presetHeaderClasses = classNames(
        'preset-duration-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const PresetDurationHeaderCell = (
        <th className={presetHeaderClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">{presetHeaderText}</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(
        EditableCellTypes.ItemPresetDuration,
        PresetDurationHeaderCell,
      );

      return formattedHeaderCells;
    }

    if (key === EditableCellTypes.ItemDuration) {
      const durationHeaderClasses = classNames(
        'duration-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const DurationHeaderCell = (
        <th className={durationHeaderClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">Duration</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(
        EditableCellTypes.ItemDuration,
        DurationHeaderCell,
      );

      return formattedHeaderCells;
    }

    const width = column.get('width');

    if (key === EditableCellTypes.ItemTitle) {
      const itemTitleHeaderClasses = classNames(
        `cs-printable-cell-width-${width}`,
        'item-title-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const ItemTitleHeaderCell = (
        <th className={itemTitleHeaderClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">Item</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(
        EditableCellTypes.ItemTitle,
        ItemTitleHeaderCell,
      );

      return formattedHeaderCells;
    }

    if (key === EditableCellTypes.ItemDescription) {
      const itemDescriptionHeaderClasses = classNames(
        `cs-printable-cell-width-${width}`,
        'item-description-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const ItemDescriptionHeaderCell = (
        <th className={itemDescriptionHeaderClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">Description</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(
        EditableCellTypes.ItemDescription,
        ItemDescriptionHeaderCell,
      );

      return formattedHeaderCells;
    }

    if (key === EditableCellTypes.ItemNote) {
      const itemNoteHeaderClasses = classNames(
        `cs-printable-cell-width-${width}`,
        'item-note-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const ItemNoteHeaderCell = (
        <th className={itemNoteHeaderClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">Private Notes</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(
        EditableCellTypes.ItemNote,
        ItemNoteHeaderCell,
      );

      return formattedHeaderCells;
    }

    if (column.has('_id')) {
      const id = column.get('_id');
      const dataHeaderCellClasses = classNames(
        `cs-printable-cell-width-${width}`,
        'data-cell',
        'printable-cell',
        'printable-header-cell',
      );
      const DataHeaderCell = (
        <th className={dataHeaderCellClasses}>
          <div className="faux-printable-header-border" />
          <div className="header-text">{column.get('title')}</div>
        </th>
      );
      formattedHeaderCells = formattedHeaderCells.set(id, DataHeaderCell);

      return formattedHeaderCells;
    }
  });

  return (
    <thead className="pdf-export-table-header">
      <tr className="pdf-export-table-row">{formattedHeaderCells}</tr>
    </thead>
  );
};

export default PrintableTableHeader;
